<template>
  <AppDialog v-model:open="isOpen" :title="options.title">
    <p style="margin:0; color:var(--muted);">{{ options.message }}</p>
    <template #footer>
      <AppButton @click="_resolve(false)">Cancel</AppButton>
      <AppButton :variant="options.danger === false ? 'primary' : 'destructive'" @click="_resolve(true)">
        {{ options.action }}
      </AppButton>
    </template>
  </AppDialog>
</template>

<script setup lang="ts">
const { isOpen, options, _resolve } = useConfirmDialog()
</script>
